import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { ChartLegendOptions, DoughnutChartComponent } from '@kinomap-dev/ng-ui-lib/charts';
import { ChartType } from '@kinomap-dev/ng-ui-lib/core';
import { IconComponent, SkeletonComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { TranslateModule } from '@ngx-translate/core';
import { CountryViewerRepartition } from '../../types/country-viewer-repartition.type';
import { Tooltip } from '../../directives/tooltip.directive';
import { ColorService } from '../../services/color.service';

@Component({
  selector: 'app-content-views-distribution-block',
  imports: [DoughnutChartComponent, SkeletonComponent, IconComponent, Tooltip, TranslateModule],
  templateUrl: './content-views-distribution-block.html',
  styleUrl: './content-views-distribution-block.scss',
})
export class ContentViewsDistributionBlock {
  readonly colorService: ColorService = inject(ColorService);

  readonly loading: InputSignal<boolean> = input<boolean>(true);
  readonly viewerRepartition: InputSignal<CountryViewerRepartition[] | undefined> =
    input<CountryViewerRepartition[]>();

  readonly chartType: ChartType = ChartType.DOUGHNUT;
  readonly chartData: Signal<number[]> = computed(() => {
    const viewerRepartition = this.viewerRepartition();
    if (!viewerRepartition || viewerRepartition.length === 0) return [];
    return viewerRepartition.map((item: CountryViewerRepartition) => item.viewers_count);
  });
  readonly chartLabels: Signal<string[]> = computed(() => {
    const viewerRepartition = this.viewerRepartition();
    if (!viewerRepartition || viewerRepartition.length === 0) return [];
    return viewerRepartition.map(
      (item: CountryViewerRepartition) => item.country?.name ?? 'Other',
    );
  });

  readonly legendOptions: Signal<ChartLegendOptions> = computed(() => ({
    position: 'right',
    align: 'start',
    boxWidth: 20,
    boxHeight: 20,
    borderRadius: 6,
    padding: 24,
    display: true,
  }));
}
